@if (isOpen()) {
  <div class="modal-overlay" (click)="close()">
    <div class="modal-container" (click)="$event.stopPropagation()">
      <!-- Header -->
      <div class="modal-header">
        <div class="header-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" stroke-width="1.5"/>
            <path d="M2 17L12 22L22 17" stroke="currentColor" stroke-width="1.5"/>
            <path d="M2 12L12 17L22 12" stroke="currentColor" stroke-width="1.5"/>
          </svg>
        </div>
        <h2>{{ 'Version Information' | translate }}</h2>
        <button class="close-btn" (click)="close()">✕</button>
      </div>
      
      <!-- Content -->
      <div class="modal-content">
        @if (loading()) {
          <div class="loading-state">
            <div class="spinner"></div>
            <span>{{ 'Loading version info...' | translate }}</span>
          </div>
        }
        @else if (error()) {
          <div class="error-state">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
              <path d="M12 8V12M12 16H12.01" stroke="currentColor" stroke-width="1.5"/>
              <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.5"/>
            </svg>
            <span>{{ error() }}</span>
            <button class="retry-btn" (click)="refresh()">Retry</button>
          </div>
        }
        @else {
          <div class="versions-container">
            <!-- Frontend -->
            <div class="version-column">
              <div class="column-header">
                <div class="small-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <rect x="2" y="3" width="20" height="14" rx="2" stroke="currentColor" stroke-width="1.5"/>
                    <path d="M8 21H16" stroke="currentColor" stroke-width="1.5"/>
                    <path d="M12 17V21" stroke="currentColor" stroke-width="1.5"/>
                  </svg>
                </div>
                <h3>{{ 'Frontend' | translate }}</h3>
              </div>
              
              @if (frontendVersion()) {
                <div class="details">
                  <div class="detail-row">
                    <span class="label">{{ 'Version' | translate }}</span>
                    <span class="value">
                      <span class="badge">{{ frontendVersion()?.version }}</span>
                      @if (frontendVersion()?.environment !== 'production') {
                        <span class="env-badge">{{ frontendVersion()?.environment }}</span>
                      }
                    </span>
                  </div>
                  <div class="detail-row">
                    <span class="label">{{ 'Branch' | translate }}</span>
                    <span class="value"><code>{{ frontendVersion()?.branch }}</code></span>
                  </div>
                  <div class="detail-row">
                    <span class="label">{{ 'Commit' | translate }}</span>
                    <span class="value">
                      <code>{{ frontendFormattedSha() }}</code>
                      <button class="copy-btn" (click)="copyFrontendShaToClipboard()">📋</button>
                    </span>
                  </div>
                  <div class="detail-row">
                    <span class="label">{{ 'Deployed' | translate }}</span>
                    <span class="value">
                      {{ frontendFormattedDeployDate() }}
                      <span class="relative">({{ frontendRelativeTime() }})</span>
                    </span>
                  </div>
                </div>
              } @else {
                <div class="no-data">Not available</div>
              }
            </div>
            
            <!-- Backend -->
            <div class="version-column">
              <div class="column-header">
                <div class="small-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z" stroke="currentColor" stroke-width="1.5"/>
                    <path d="M8 8H16" stroke="currentColor" stroke-width="1.5"/>
                    <path d="M8 12H14" stroke="currentColor" stroke-width="1.5"/>
                  </svg>
                </div>
                <h3>
                  {{ 'Backend' | translate }}
                  @if (!hasBackend()) {
                    <span class="offline">offline</span>
                  }
                </h3>
              </div>
              
              @if (backendVersion()) {
                <div class="details">
                  <div class="detail-row">
                    <span class="label">{{ 'Branch' | translate }}</span>
                    <span class="value"><code>{{ backendVersion()?.branch }}</code></span>
                  </div>
                  <div class="detail-row">
                    <span class="label">{{ 'Commit' | translate }}</span>
                    <span class="value">
                      <code>{{ backendFormattedSha() }}</code>
                      <button class="copy-btn" (click)="copyBackendShaToClipboard()">📋</button>
                    </span>
                  </div>
                  <div class="detail-row">
                    <span class="label">{{ 'Deployed' | translate }}</span>
                    <span class="value">
                      {{ backendFormattedDeployDate() }}
                      <span class="relative">({{ backendRelativeTime() }})</span>
                    </span>
                  </div>
                  <div class="detail-row">
                    <span class="label">{{ 'Server Time' | translate }}</span>
                    <span class="value">{{ backendVersion()?.serverTime | date:'medium' }}</span>
                  </div>
                </div>
              } @else {
                <div class="no-data">
                  Not available
                  <button class="refresh-btn" (click)="refresh()">⟳</button>
                </div>
              }
            </div>
          </div>
        }
      </div>
      
      <!-- Footer -->
      <div class="modal-footer">
        <button class="close-modal-btn" (click)="close()">{{ 'Close' | translate }}</button>
      </div>
    </div>
  </div>
}